import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircleIcon, MoonIcon, PhoneIcon } from 'lucide-react';
import { ActionLink } from './Buttons';
import { ArchiveStamp } from './ArchiveStamp';
import { PolaroidVideo } from './PolaroidVideo';
import { contact } from '../data/contact';
import { heroVideoSrc } from '../data/media';
interface HeroProps {
  lockup: string;
}
export function Hero({
  lockup
}: HeroProps) {
  return <section id="inicio" aria-labelledby="hero-title" className="relative isolate overflow-hidden bg-plum-deep" data-id="element-86" data-mp="1285x3nzc5smb">
      <div aria-hidden="true" className="smoke-veil pointer-events-none absolute inset-0" data-id="element-87" data-mp="x8jojrugd0ju" />
      <div aria-hidden="true" className="gold-dust pointer-events-none absolute inset-0 opacity-70" data-id="element-88" data-mp="ncgl8inv6vvb" />
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 bg-gradient-to-b from-ink/60 via-transparent to-ink/80" data-id="element-89" data-mp="3d1sayygxbltn" />

      <div className="relative mx-auto w-full max-w-5xl px-5 py-16 text-center sm:px-8 sm:py-24" data-id="element-90" data-mp="384s5aonzkl32">
        <motion.div initial={{
        opacity: 0,
        y: 26
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: [0.22, 1, 0.36, 1]
      }} className="flex flex-col items-center" data-id="element-91" data-mp="3j6odtpknkwsq">
          <ArchiveStamp icon={<MoonIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-93" data-mp="3e7uwtn65qnnt" />} data-id="element-92" data-mp="3e8wi0kgw0qj9">
            {lockup}
          </ArchiveStamp>

          <h1 id="hero-title" className="mt-8 max-w-3xl font-display text-[1.9rem] font-light uppercase leading-[1.12] tracking-[0.05em] text-paper sm:text-[2.8rem] lg:text-[3.3rem]" data-id="element-94" data-mp="30fy9dwffp1xr">
            Rituales y Orientación Espiritual para el Amor y la Vida Personal
          </h1>

          <p className="mt-6 max-w-2xl text-base leading-relaxed text-body sm:text-lg" data-id="element-95" data-mp="2hj5fbxyfzx2d">
            Conoce prácticas tradicionales de brujería, hechicería y chamanismo a
            través de consultas personalizadas.
          </p>

          <div className="mt-11 w-full sm:mt-14" data-id="element-96" data-mp="s2b7vyavsj55">
            <PolaroidVideo src={heroVideoSrc} caption="Archivo · Presentación del templo" autoSound tiltClassName="-rotate-[1.4deg]" data-id="element-97" data-mp="s44i1nkpdlhw" />
          </div>

          <div className="mt-11 flex w-full flex-col items-center gap-3.5 sm:w-auto sm:flex-row sm:justify-center" data-id="element-98" data-mp="dd5ews2mzp5p">
            <ActionLink href={contact.whatsappHref} variant="emerald" target="_blank" rel="noreferrer" className="w-full sm:w-auto" aria-label={`Hablar por WhatsApp al ${contact.whatsapp}`} data-id="element-99" data-mp="1b1fe6zb1fyt4">
              <MessageCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-100" data-mp="x1edpkyoqte6" />
              Hablar por WhatsApp
            </ActionLink>
            <ActionLink href={contact.phoneHref} variant="outline" className="w-full sm:w-auto" aria-label={`Llamar ahora al ${contact.phone}`} data-id="element-101" data-mp="3lu081ftmtv6l">
              <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-102" data-mp="1xaw06rmvemay" />
              Llamar Ahora
            </ActionLink>
          </div>

          <p className="mt-9 font-folio text-[0.68rem] uppercase tracking-[0.18em] text-body/70" data-id="element-103" data-mp="218jzs7zid396">
            Servicio exclusivo para mayores de edad.
          </p>
        </motion.div>
      </div>
    </section>;
}